// extracted by mini-css-extract-plugin
export default {"image":"Step2_image__PtMVC","submitBtn":"Step2_submitBtn__u-P6r","step2Container":"Step2_step2Container__IzQxr","retryBtn":"Step2_retryBtn__6iyAh"};